import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MAX_PROJECT_TITLE_LENGTH } from '../const';
import { projectPKSelector, projectTitleSelector } from '../reducers/selectors';
import { useModalState } from '../utils/useModalState';
import { copyProject } from '../utils/zoomServices';
import { Button } from './Button';
import { FormField } from './FormField';
import { Modal } from './Modal';
import { showGenericErrorModal } from '../ducks/modals';

export function SaveCopyModal({ show, onHide }) {
  const [title, setTitle] = useModalState(show, useInitialTitle());
  const projectPK = useSelector(projectPKSelector);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = useCallback(async () => {
    setLoading(true);
    try {
      await copyProject(title, projectPK);
      // TODO navigate to the new project
      onHide();
    } catch {
      dispatch(showGenericErrorModal());
    }
  }, [title, projectPK, onHide, dispatch]);

  return (
    <Modal
      show={show}
      title="Save a Copy"
      onHide={onHide}
      onSubmit={onSubmit}
      disableHide={loading}
      footer={
        <>
          <Button
            onClick={onHide}
            variant="tertiary"
            width="140px"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            width="182px"
            loading={loading}
            disabled={!title}
          >
            Continue
          </Button>
        </>
      }
    >
      <FormField
        type="text"
        label="Project title"
        value={title}
        onChange={setTitle}
        autoFocus
        required
        maxLength={MAX_PROJECT_TITLE_LENGTH}
      />
    </Modal>
  );
}

function useInitialTitle() {
  return `${useSelector(projectTitleSelector)} Copy`.slice(
    0,
    MAX_PROJECT_TITLE_LENGTH,
  );
}
